<template>
    <div class="monitorDetails">
        <div class="container">
            <!--      导航      -->
            <div class="nav">
                <span>监测详情</span>
                <span class="all_result">全部结果 > </span>
                <span style="font-size:14px;">{{ allResults }}个结果</span>
            </div>

            <div class="monitorDetails_main">
                <div class="monitorDetails_main_title">
                    <ul class="title_group">
                        <li
                                @click="optionSwitch"
                                :data-index="index"
                                v-for="(item,index) in monitorTotalData"
                                :class=" optionValue == index ? 'active title_item' : 'title_item'">
                            {{item.name}}（{{item.total}}）
                        </li>
                    </ul>
                    <div class="title_btn_group">
                        <a v-if="reportUrl && reportUrl!='' " :href="reportUrl"  class="gray_btn">下载报告</a>
                        <span @click="goBack" style="width: 104px;margin-left: 20px;" class="gray_btn">返回监测明细</span>
                    </div>
                </div>
                <p class="tips_text" v-if="noData && pageNum == 1">您所选的监测范围暂未监测出传播数据</p>
                <ul v-else class="monitorDetails_group">
                    <monitorItem class="result_item" v-for="(item,index) in DetailsData" :data="item"></monitorItem>
                </ul>
            </div>

            <div v-if="!noData" @click="loadMore" class="gray_btn large">加载更多</div>
            <div v-else style="cursor: default;" class="no_data large">没有更多数据了</div>
        </div>
    </div>
</template>

<script>
    import {_monitorTotal, _getValidByPage} from '@/api/monitor.js';
    import monitorItem from "@/views/vipClip/monitor/components/monitorItem";
    import Cookies from "js-cookie";


    export default {
        metaInfo: {
            title: '监测详情|时尚知识产权保护平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: ''
            }, {
                name: 'Description',
                content: ''
            }]
        },
        name: "monitorDetails",
        components: {
            monitorItem
        },
        data() {
            return {
                userInfo: '', //用户信息
                allResults: '', //全部结果
                monitorId: '', //监测id
                monitorTotalData: [], //分类列表
                DetailsData: [], //详情列表
                reportUrl:'', //监测报告url
                optionValue: 0, //当前选中分类
                pageNum: 1, //当前页数
                pageSize: 12, //当前请求数据尺寸
                loadMoreFlag: true, //是否可以点击加载更多
                noData: false //分页无数据

            }
        },
        created() {
            if (Cookies.get("userInfo") && Cookies.get("userInfo") != '') {
                this.userInfo = JSON.parse(Cookies.get("userInfo"));
                if (this.$route.query.id && this.$route.query.id != '') {
                    this.monitorId = this.$route.query.id;
                    this.monitorTotal();
                }


            } else {
                this.$router.push("/login");
            }
        },
        methods: {
            /******************tab切换事件*******************/
            optionSwitch(data) {
                let newIndex = this.optionValue;
                let nowIndex = data.target.dataset.index;

                if (newIndex != nowIndex) {
                    this.optionValue = nowIndex;
                    this.DetailsData = [];
                    this.pageNum = 1;
                    this.noData = false;
                    this.getValidByPage();
                }
            },

            /******************获取分类信息*******************/
            monitorTotal() {
                let data = {contentId: this.monitorId};
                _monitorTotal(data).then(res => {
                    if (res.code == 200) {
                        let monitorTotalData = res.result.array;
                        this.allResults = res.result.total;
                        this.reportUrl = res.result.reportUrl;
                        this.monitorTotalData = monitorTotalData;
                        this.optionValue = 0;
                        this.getValidByPage();
                    }
                }, (err) => {
                    console.log(err);
                })
            },

            /******************获取详情页信息*******************/
            getValidByPage() {
                let nowItem = this.monitorTotalData[this.optionValue];
                let data = {
                    contentId: nowItem.contentId,
                    scopeId: nowItem.scopeId,
                    platformId: nowItem.platformId,
                    pageNumber: this.pageNum,
                    pageSize: this.pageSize,
                    sort: 'create_date',
                    order: 'desc'
                };
                _getValidByPage(data).then(res => {
                    this.loadMoreFlag = false;
                    if (res.code == 200) {
                        let records = res.result.records;
                        if (records.length != 0) {
                            this.DetailsData = this.DetailsData.concat(records);
                            this.pageNum = this.pageNum - 0 + 1;
                        } else {
                            this.noData = true;
                        }
                    }

                    this.loadMoreFlag = true;
                }, (err) => {
                    this.loadMoreFlag = true;
                })

            },

            /******************加载更多*******************/
            loadMore() {
                if (this.loadMoreFlag) {
                    this.getValidByPage();
                }
            },

            /******************返回上一页*******************/
            goBack() {
                this.$router.replace('/monitoring?id=' + this.monitorId);
            }
        }
    }
</script>

<style scoped lang="less">
    ul, ol {
        list-style: none;
    }

    .container {
        width: 1334px;
        margin: 0 auto;
    }

    .monitorDetails {
        min-height: 600px;
    }

    .monitorDetails .nav {
        padding: 20px 0;
        color: #333333;
        font-size: 16px;
    }

    .nav .all_result {
        padding-left: 15px;
        font-size: 14px;
    }

    .monitorDetails_main {
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
        border-radius:2px;
    }

    .monitorDetails_main .monitorDetails_main_title {
        box-shadow: 0 2px 40px 0 rgba(29, 31, 108, 0.04);
        border-radius: 2px 2px 0 0;
        display: flex;
        justify-content: space-between;
        padding: 15px 20px;
    }

    .monitorDetails_main_title .title_group {
        display: flex;
        max-width: 80%;
        /*flex-wrap: nowrap;*/
        overflow-x: auto;
        overflow-y: hidden;
        padding-top: 8px;
        line-height: 1;
    }

    .title_group .title_item {
        margin-right: 25px;
        color: #999999;
        font-size: 14px;
        padding-bottom: 5px;
        cursor: pointer;
        white-space: nowrap;

    }

    .title_group .title_item.active {
        border-bottom: 1px solid #333333;
        color: #333333;
    }

    .title_btn_group {
        display: flex;
    }

    .monitorDetails_main .tips_text {
        font-size: 15px;
        text-align: center;
        padding: 20px 0;
    }

    .monitorDetails_main .monitorDetails_group {
        padding: 20px 14px;
        display: flex;
        flex-wrap: wrap;
    }

    .monitorDetails_group .result_item {
        margin: 0 15px 42px 0;

    }

    .monitorDetails_group .result_item:nth-child(6n) {
        margin-right: 0;
    }

    .gray_btn, .no_data {
        width: 84px;
        height: 33px;
        line-height: 33px;
        outline: none;
        background: #f6f6f6;
        border-radius: 2px;
        border: 1px solid #efefef;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        cursor: pointer;
        text-align: center;
    }

    .gray_btn:hover {
        background: rgba(18,18,16,1);
        color:#fff;
        border: 1px solid rgba(18,18,16,1);
    }

    .gray_btn.large, .no_data.large {
        width: 364px;
        height: 50px;
        line-height: 50px;
        font-size: 14px;
        margin: 30px auto;
    }


</style>